<template>
  <ul
    class="autocomplete__suggestions mention-autocomplete"
    v-if="suggestions.length > 0"
    tabindex="-1"
    @keydown.enter.prevent="setCurrentSelected"
    @keydown.tab.prevent="setCurrentSelected"
    @keydown.space.prevent="setCurrentSelected"
    @keydown.down.prevent="next"
    @keydown.up.prevent="previous"
    @keydown.left.prevent="close('left')"
    @keydown.right.prevent="close('right')"
    @keydown.esc.prevent="close"
    @keydown.delete.prevent="close"
  >
    <li
      v-for="(suggestion, index) in suggestions"
      :key="index"
      @click="setSelected(suggestion)"
      @focus="setSelected(suggestion)"
      class="autocomplete-item"
      :class="{ 'autocomplete-item--active': activeIndex === index }"
      tabindex="-1"
    >
      <div class="autocomplete-item__image">
        <img :src="suggestion.avatar_url" alt="" />
      </div>
      <div class="autocomplete-item__content">
        <div
          class="autocomplete-item__name"
          v-html="suggestion.highlighted_name"
        ></div>
        <div class="autocomplete-item__slug">
          grabcad.com/<span v-html="suggestion.highlighted_cached_slug"></span>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
let MIN_QUERY_LENGTH = 1;
import axios from 'axios'

export default {
  props: ["searchQuery"],
  created () {
    this.api = axios.create({
      baseURL: "/groups/" + Grabcad.currentGroup + "/member_search",
      params: { format: "json" }
    });

    this.$eventHub.$on("mentionAutocompleteClose", this.close);
    this.$eventHub.$on("mentionAutocompleteKeypress", this.focus);
    this.$eventHub.$on("mentionAutocompleteConfirm", this.confirm);
  },

  mounted () {
    this.debouncedSearch(this.searchQuery);
  },

  destroyed () {
    this.$eventHub.$off("mentionAutocompleteClose", this.close);
    this.$eventHub.$off("mentionAutocompleteKeypress", this.focus);
    this.$eventHub.$off("mentionAutocompleteConfirm", this.confirm);
  },

  data () {
    return {
      suggestions: [],
      activeIndex: 0,
      focused: false,
      open: false
    };
  },

  methods: {
    search () {
      if (!this.query || this.query.length < MIN_QUERY_LENGTH) return;
      let params = {
        query: this.query.trim(),
        existing: true
      };

      this.api.get("/", { params: params }).then(this.requestSuccess);
    },

    debouncedSearch (query) {
      this.query = query;
      this.debounceSearch =
        this.debounceSearch || Grabcad.debounce(this.search, 250);
      this.debounceSearch();
    },

    requestSuccess (response) {
      if (!this.open) return;
      this.suggestions = response.data.results;
    },

    setSelected (item) {
      this.$eventHub.$emit("mentionSelection", item);
    },

    setCurrentSelected () {
      this.setSelected(this.suggestions[this.activeIndex]);
      this.close();
    },

    focus (key) {
      if (key === "up") this.previous();
      if (key === "down") this.next();

      this.$eventHub.$emit("mentionAutocompleteFocusChange", true);

      if (
        typeof this.$el !== "undefined" &&
        typeof this.$el.focus === "function"
      ) {
        this.$el.focus();
      }

      this.focused = true;
    },

    close (direction) {
      this.$eventHub.$emit("mentionAutocompleteFocusChange", false, direction);
      this.suggestions = [];
      this.activeIndex = 0;
      this.focused = false;
      this.open = false;
    },

    next () {
      if (this.activeIndex < this.suggestions.length - 1) this.activeIndex++;
    },

    previous () {
      if (this.activeIndex > 0) this.activeIndex--;
    },

    confirm () {
      if (!this.suggestions.length || !this.suggestions[this.activeIndex])
        return;
      setTimeout(this.setCurrentSelected, 0);
    }
  },
  watch: {
    suggestions (newValue) {
      let visible = newValue && newValue.length > 0;
      this.$eventHub.$emit("mentionAutocompleteVisibilityChange", visible);
    },
    searchQuery (query) {
      this.open = true;
      this.debouncedSearch(query);
    }
  }
};
</script>
